export const environment = {
  production: false,
  apiUrl: 'https://staging-app.sopbuildai.com/SOP-Backend/library'
};